export default "__VITE_ASSET__240cdd9a__"